export enum SocietyType {
  HOUSING_COOPERATIVE = 0,
  HOMEOWNERS_ASSOCIATION = 1,
  REAL_ESTATE_DEVELOPER = 2,
  NEIGHBOURHOOD = 3,
  APARTMENT_BUILDING = 4,
}
